import React, { ReactNode } from 'react';

import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type AccountDetailsRowProps = {
    label: string;
    subLabel?: string | ReactNode;
    renderAction?: () => ReactNode;
};

export const AccountDetailsRow = ({ label, subLabel, renderAction }: AccountDetailsRowProps) => {
    return (
        <Row
            alignItems="center"
            justifyContent="space-between"
            paddingVertical="s16"
            borderBottomWidth={1}
            borderBottomColor={ds.colorToken.border.strong}
        >
            <Box>
                <Text color={ds.colorToken.text.secondary} variant="bodySmall">
                    {label}
                </Text>
                {typeof subLabel === 'string' ? <Text variant="bodyMedium">{subLabel}</Text> : subLabel}
            </Box>
            {renderAction ? renderAction() : null}
        </Row>
    );
};
